import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'ed-subject-builder-content-sidebar'
})
export default class EdSubjectBuilderContentSidebarComponent extends Vue {
  
  closeContentSidebar() {
    this.$emit('onCloseContentSidebar');
  }
}
